import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiX } from "react-icons/fi";

import { BiPencil } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import {
  createUOM,
  getAllUOMs,
  RESET_UNIT_OF_MEASURE,
  selectSuccessCreateUpdate,
  updateUOM,
} from "../../redux/features/unitOfMeasure/UnitOfMeasureSlice";

const CreateUpdateUnitOfMeasure = ({ unitOfMeasure }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const isSuccess = useSelector(selectSuccessCreateUpdate);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && unitOfMeasure) {
      setName(unitOfMeasure?.name);
    }
  }, [unitOfMeasure, isOpen]);

  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
    setName("");

    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!name) newErrors.name = "Unit of measure name is requried";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (unitOfMeasure) {
      const id = unitOfMeasure._id;

      await dispatch(updateUOM({ id, name }));
    } else {
      await dispatch(createUOM(name));
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(getAllUOMs());
      dispatch(RESET_UNIT_OF_MEASURE());
      handleClose();
    }
  }, [isSuccess, dispatch]);

  return (
    <div>
      {/* Button to open the modal */}

      {unitOfMeasure ? (
        <button
          onClick={handleOpen}
          className="absolute text-white bg-[#20BEC6CC] rounded-lg p-[4px] top-2 right-2"
        >
          <BiPencil className="size-4" />
        </button>
      ) : (
        <button
          onClick={handleOpen}
          className="absolute bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
        >
          <FaPlus className="md:text-xl text-[1rem]" />
        </button>
      )}

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] md:w-[550px] w-[90%] mx-auto p-6 space-y-3">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-4 mb-4">
              <h1 className="md:text-[1.5rem] text-[1rem] font-bold text-[#0D868C]">
                {unitOfMeasure
                  ? "Update Unit Of Measure"
                  : "Create Unit Of Measure"}
              </h1>
              <button type="button" onClick={handleClose}>
                <FiX className="md:size-8 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Unit of Measure
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Enter the unit of measure"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  className="text-white bg-[#0D868C] md:w-[56%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  {unitOfMeasure
                    ? "Update Unit Of Measure"
                    : "Create Unit Of Measure"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateUpdateUnitOfMeasure;
